import createIcon from '../../createIcon';

/**
 * @component @name CallSplit
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgNEwxNi4yOSA2LjI5TDEzLjQxIDkuMTdMMTQuODMgMTAuNTlMMTcuNzEgNy43MUwyMCAxMFY0SDE0Wk0xMCA0SDRWMTBMNi4yOSA3LjcxTDExIDEyLjQxVjIwSDEzVjExLjU5TDcuNzEgNi4yOUwxMCA0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CallSplit = createIcon('CallSplit', [
  [
    'path',
    {
      d: 'M14 4L16.29 6.29L13.41 9.17L14.83 10.59L17.71 7.71L20 10V4H14ZM10 4H4V10L6.29 7.71L11 12.41V20H13V11.59L7.71 6.29L10 4Z',
      key: '1s8qug',
    },
  ],
]);

export default CallSplit;
